import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import {
  MIDDLE_WARE_BASE_URL_v1,
  PRODUCTION_SCHEDULE,
} from "../../../utils/CONSTANTS";

const initialState = {
  productionScheduleState: "pending",
  productionScheduleData: null,
};

export const productionSchedule = createAsyncThunk(
  "get/productionSchedule",
  async (data: any) => {
    const response = axios.getRequest(
      MIDDLE_WARE_BASE_URL_v1() +
        PRODUCTION_SCHEDULE() +
        "?classRosterId=" +
        data?.classRosterId +
        "&classRequestId=" +
        data?.classRequestId
    );
    return response;
  }
);

const productionScheduleSlice = createSlice({
  name: "productionSchedule",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(productionSchedule.pending, (productionScheduleState) => {
        productionScheduleState.productionScheduleState = "pending";
      })
      .addCase(
        productionSchedule.fulfilled,
        (productionScheduleState, action) => {
          let tempRes = action.payload.data;
          if (typeof tempRes === "string") {
            tempRes = JSON.parse(tempRes);
          }

          productionScheduleState.productionScheduleState = "fulfilled";
          productionScheduleState.productionScheduleData = tempRes;
          //console.log("Insisde Slice ", tempRes);
        }
      )
      .addCase(productionSchedule.rejected, (productionScheduleState) => {
        productionScheduleState.productionScheduleState = "failed";
      }),
});

export const productionScheduleDetails = (state: any) =>
  state.productionSchedule;

export default productionScheduleSlice.reducer;
